export interface FlightType {
    id: string,
    name: string
}

export const DefaultFlightType: FlightType = {
    id: '',
    name: ''
}